var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.comp,_vm._b({tag:"component"},'component',_vm.attrs,false),[_vm._t("default"),_vm._v(" "),(!_vm.skipContainer)?_vm._t("with-container"):_vm._e(),_vm._v(" "),(_vm.skipContainer)?_vm._t("without-container"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }